module.exports = __webpack_public_path__ + "img/saucepan-mobile.2bc8248f.png";